import { createGlobalStyle, css } from 'styled-components'
import { Colors } from '../../styles/colors'

const fonts = css`
	/* moved to css styles */
	/* @font-face {
		font-family: 'Akkurat';
		src: url('/assets/fonts/AkkuratLLWeb-Regular.woff2') format('woff2'), url('/assets/fonts/AkkuratLLWeb-Regular.woff') format('woff'), local('Akkurat'), url('/assets/fonts/FontsFree-Net-Akkurat.ttf') format('ttf');
		font-weight: 400;
		font-style: normal;
	}
	@font-face {
		font-family: 'Akkurat';
		src: url('/assets/fonts/AkkuratLLWeb-Bold.woff2') format('woff2'), url('/assets/fonts/AkkuratLLWeb-Bold.woff') format('woff'), local('Akkurat Bold'), local('AkkuratBold'), url('/assets/fonts/FontsFree-Net-Akkurat-Bold.ttf') format('ttf');
		font-weight: 700;
		font-style: normal;
	} */
`

const reset = css`
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	a {
		color: inherit;
		text-decoration: inherit;
	}
	
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: 100%;
	}
	
	button {
		background-color: transparent;
		border: none;
		font-size: inherit;
		font-family: inherit;
		color: inherit;

		cursor: pointer;

		&[disabled] {
			cursor: default;
		}

		&:focus {
			outline: none;
		}
	}
	
	input {
		font-family: inherit;
	} icspicture {
		line-height: 0;
	}
`

export const CommonStyleProvider = createGlobalStyle`
	${fonts}
	${reset}

	html {
		font-size: 16px;
		-webkit-text-size-adjust: 100%;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	body {
		font-family: 'Akkurat';
		font-size: 1rem;
		line-height: 1.25;
		color: ${(props) => props.theme['fontPrimary']};
		// overscroll-behavior: none;
		scroll-behavior: smooth;
	}
`

export const THEME = {
	default: {
		fontPrimary: Colors.grayDark,
		fontSecondary: Colors.grayDark,
		fontHighlight: Colors.white,
	},
	highlight: {
		fontPrimary: Colors.white,
		fontSecondary: Colors.white,
		fontHighlight: Colors.grayDark,
	},
}
